export const SURVEY_QUESTION_MAX_CHARACTERS_SYSTEM = 1000;
